import Styles from './MenubarItem.scss';

import Template from './MenubarItem.hbs';
import Avatar from 'views/components/avatar/Avatar.svelte';

export default class MenubarItem extends BaseView {

    // Resolves the actual menu-item link, whether it's this view's root element
    // (the common case) or nested inside it (when a quick-logout button sits next to it).
    get $link() {
        return this.$el.hasClass('js-link') ? this.$el : this.$('.js-link')
    }

    initialize({
        type,
        title,
        icon,
        url,
        isMainItem,
        menubar,
        avatar
    }) {

        this.type = type;

        // Only the desktop settings/account item (avatar + name) gets a quick-logout
        // shortcut next to it. On mobile there's already a full-width 'logout' item.
        const hasQuickLogout = type === 'settings' && !ISMOBILE

        this.setElement(Template({
            Styles,
            type,
            url,
            title,
            icon,
            isMainItem,
            hasQuickLogout
        }));

        this.listenTo(menubar, 'changedLink', this.onChangeLink);

        // Add type specific logic here. For example: if it's a logout
        // button we shouldn't use the a-tag href logic, but call logout
        // on the usermodel.
        switch (this.type) {
            case 'more':
                this.$el.on('click', menubar.toggleFlyout)
                break;
            case 'support':
                this.$el.on('click', this.onClickSupportButton)
                break;
            case 'settings':
                this.$link.on('click', Backbone.View.layout.openAccountSettings)
                break;
            case 'logout':
                this.$el.on('click', Backbone.Model.user.logOut)
                break;
        }

        this.$('.js-quick-logout').on('click', this.onClickQuickLogout)

        if (ISMOBILE) {
            this.$el.on('click', menubar.closeMenu)
        }

        if (avatar) {
            this.setAvatar()
            this.listenTo(Backbone.Model.user, 'change:avatar', () => this.setAvatar())
        }
    }

    onChangeLink({ action, controller }) {
        this.$link.removeClass(Styles['is-active']);

        // Prevents library/home from activating the home button
        if (this.type === 'home' && controller === 'library') {
            return;
        }

        // Prevents words/home from activating the home button
        if (this.type === 'home' && controller === 'words') {
            return;
        }

        // Managing a single group's settings (reached from the "My classes" group cards,
        // not from a menu item of its own) should highlight "My classes", not the account
        // settings item - even though both routes happen to share the "settings" action name.
        if (controller === 'groups' && action === 'settings') {
            if (this.type === 'home') {
                this.$link.addClass(Styles['is-active']);
            }
            return;
        }

        // Prevents overview/progress from activating the groups/progress button
        if (this.type === 'progress' && controller === 'overview') {
            return;
        }

        if (this.type === 'progressOverview' && controller === 'overview' && action === 'progress') {
            this.$link.addClass(Styles['is-active']);
            return;
        }

        if (this.type === controller || this.type === action) {
            this.$link.addClass(Styles['is-active']);
        }
    }

    onClickQuickLogout() {
        Backbone.View.layout.openConfirmStatus(
            window.i18n.gettext('Are you sure you want to log out?'),
            Backbone.Model.user.logOut,
            () => {},
            window.i18n.gettext('Logout'),
            undefined,
            undefined,
            'outlined-danger',
            'logout',
            'arrow-right'
        )
    }

    onClickSupportButton() {

        // Open the support modal
        Backbone.View.layout.showSupport();

        // Log statsTracker for when user clicks on support button with the current URL.
        // This is logged in Matomo under the category 'supportButton'.
        Tracking.trackEvent(
            'supportButton',
            window.app.controller.activePath.join('/')
        );
    }

    setBadge(number) {
        this.$('.js-badge').attr('badge-number', number);
    }

    setAvatar() {
        this.unregisterAndDestroyChildView(this.avatar)
        this.avatar = this.addSvelteChildView('.js-icon-holder', Avatar, {
            avatar: Backbone.Model.user.get('avatar')
        })
    }
}
